import React from 'react';
import { productAssets, productViewLabels } from '../../data/images';
import type { ProductView } from '../../data/images';
import { heroArtwork } from '../../data/heroArtwork';
type ProductAssetSlotProps = {
  view: ProductView;
  className?: string;
  compact?: boolean;
  tone?: 'dark' | 'studio';
};

/**
 * Shows the M1 PRO photograph for the requested view when supplied and verified.
 * Until then it shows the owner-approved M1 PRO artwork from the hero set.
 */
export function ProductAssetSlot({
  view,
  className = '',
  compact = false,
  tone = 'dark'
}: ProductAssetSlotProps) {
  const asset = productAssets[view];
  const label = productViewLabels[view];
  if (asset.src && asset.ledCountVerified) {
    return <img src={asset.src} alt={`M1 PRO — ${label}`} loading="lazy" className={`object-contain ${className}`} data-id="element-480" data-mp="3oxe2lrgqh30g" />;
  }
  const {
    src,
    width,
    height,
    product
  } = heroArtwork.mobile;
  const bg = tone === 'studio' ? 'bg-[#0E1824]' : 'bg-graphite';
  // Crop the product from the approved artwork via background positioning.
  const sizeX = width / product.w * 100;
  const sizeY = height / product.h * 100;
  const posX = product.x / (width - product.w) * 100;
  const posY = product.y / (height - product.h) * 100;
  return <div role="img" aria-label={`MarineForceLED M1 PRO with Magnetic Mount System`} className={`relative flex items-center justify-center overflow-hidden rounded-xl border mf-hairline ${bg} ${className}`} data-id="element-481" data-mp="cnxyjk5pdhw9">
      <div className={`w-full ${compact ? 'max-w-[140px]' : 'max-w-[520px]'}`} style={{
      aspectRatio: `${product.w} / ${product.h}`,
      backgroundImage: `url(${src})`,
      backgroundSize: `${sizeX}% ${sizeY}%`,
      backgroundPosition: `${posX}% ${posY}%`,
      backgroundRepeat: 'no-repeat'
    }} data-id="element-482" data-mp="10bpm5jwp1hcu" />
    </div>;
}